import { Flex, Spacing, Text } from '@billy/design-system'
import React from 'react'

import { VatDeclarationsReportField } from '@features/vatDeclarations/types/vatDeclarationsReportField'
import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useFetchAdditionalFields } from '@views/settings/routes/VatReturnSettings/elements/AdditionalFields/hooks/useFetchAdditionalFields'

import { SortDirection } from '../../../../../../../../../enums/sortDirection'
import { formatAmountWithCurrency } from '../../../../../../../utils/formatAmountWithCurrency'
import { TableLabel } from '../TableLabel'
import { BodyCell } from './styles'

interface TableBodyProps {
  tableRowsData: VatDeclarationsReportField[]
}

export const TableBody = ({ tableRowsData }: TableBodyProps) => {
  const { organization } = useUserOrganization()
  const { data } = useFetchAdditionalFields({ sortDirection: SortDirection.Asc })

  const currency = organization?.baseCurrencyId
  const locale = organization?.localeId

  const renderContent = (text: string) => (
    <Flex alignItems="center" justifyContent="flex-end">
      <Text>{text}</Text>
    </Flex>
  )

  return (
    <>
      {tableRowsData.map(({ name, turnoverAmount, vatAmount }: VatDeclarationsReportField) => {
        const amountWithCurrency = vatAmount
          ? formatAmountWithCurrency({
              amount: vatAmount,
              locale,
              currency,
            })
          : '0'

        const turnoverAmountWithCurrency = turnoverAmount
          ? formatAmountWithCurrency({
              amount: turnoverAmount,
              locale,
              currency,
            })
          : '0'

        const additionalDescription = data?.find((category) => category?.name === name)?.description

        // If both values are null, leave the table cell empty to indicate an error.
        // Normally, one value should be null and the other should contain a valid value.
        const renderAmount = () => {
          if (typeof vatAmount === 'number') {
            return renderContent(amountWithCurrency)
          } else if (typeof turnoverAmount === 'number') {
            return renderContent(turnoverAmountWithCurrency)
          } else {
            return null
          }
        }

        return (
          <tr>
            <BodyCell>
              <Flex gap={Spacing.S8}>
                <TableLabel name={name} additionalDescription={additionalDescription} />
              </Flex>
            </BodyCell>
            <BodyCell>{renderAmount()}</BodyCell>
          </tr>
        )
      })}
    </>
  )
}
